<div fxLayout="column" class="layout-padd scrolled" fxFlexFill [ngStyle]="{'max-height.px': innerHeight}">

  <!-- Select Comp  -->
  <div fxLayout="column" fxLayoutGap="20px" fxLayoutGap.xs="10px" *ngIf="currComp === 'select'" class="layout-padd">

    <div fxLayout="row" fxLayoutAlign="space-between center">
      <span class="mat-headline boldest">{{'PaymentMethodComponent.opt'|translate}}</span>
    </div>

    <!-- Boucle sur les cartes de paiement (stripe)-->
    <!-- <div fxLayout="column" fxLayoutGap="10px" *ngIf="currSM.enable_online_payment> 0 &&
        currPOS.stripe_account && clientCards">

      <div fxLayout="row" class="fake-form-field-endorder" *ngFor="let card of clientCards; let index = index;"
        (click)="selectStripeCard(card)"> -->

    <!-- Radio btn -->
    <!-- <div fxLayoutAlign="center center" style="padding: 10px;">
          <div class="fake-radio"
            *ngIf="currPaymentMethod !== 'online' ||  currPaymentMethod === 'online' && currCard$ && currCard$.created !== card.created">
          </div>
          <div class="fake-radio primary" fxLayoutAlign="center center"
            *ngIf="currPaymentMethod === 'online' && currCard$ && currCard$.created === card.created"><i
              class="fas fa-check whited-ico" style="font-size: 10px;"></i></div>
        </div> -->

    <!-- card infos -->
    <!-- <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" fxFlex>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <img src=" {{card.card.logo_src}}" class="rad-bord logo-card"
              *ngIf="card.card.brand !== 'visa' && card.card.brand !== 'mastercard'">
            <img src="assets/img/refonte-logo/VISA.png" height="40" *ngIf="card.card.brand === 'visa'">
            <img src="assets/img/refonte-logo/MASTERCARD.png" height="40" *ngIf="card.card.brand === 'mastercard'">
            <span class="mat-subheading-1 boldest">{{card.card.brand | capitalize}}</span>
          </div>
          <span class="mat-subheading-1" style="color:grey" fxHide.xs>**** **** **** {{card.card.last4}}</span>
          <span class="mat-subheading-1" style="color:grey" fxHide fxShow.xs>**** {{card.card.last4}}</span>
        </div>

        <div fxLayoutAlign="center center" class="layout-padd">
          <mat-icon mat-icon-button class="dark-ico" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation();">
            more_vert</mat-icon>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openDialDeletCard(card, index); $event.stopPropagation();"
              angulartics2On="click" angularticsAction="openDeleteDialog"
              angularticsCategory="paymentMethods">{{"basket.delete" |
              translate}}</button>
          </mat-menu>
        </div> -->


    <!-- </div> -->

    <!-- </div> -->



    <!-- Boucle sur les moyens de paiement (stripe)-->
    <div fxLayout="column" fxLayoutGap="10px" *ngIf="currSM.enable_online_payment> 0 &&
  currPOS.stripe_account && clientCards">

      <div fxLayout="row" *ngFor="let card of clientCards; let index = index;" (click)="selectStripeCard(card)">

        <div fxLayout="row" fxFlexFill class="fake-form-field-endorder" *ngIf="card.type !=='sepa_debit'">

          <!-- Radio btn -->
          <div fxLayoutAlign="center center" style="padding: 10px;">
            <div class="fake-radio"
              *ngIf="!currCard$|| currPaymentMethod !== 'online' ||  currPaymentMethod === 'online' && currCard$ && currCard$.created !== card.created">
            </div>
            <div class="fake-radio primary" fxLayoutAlign="center center"
              *ngIf="currPaymentMethod === 'online' && currCard$ && currCard$.created === card.created"><i
                class="fas fa-check whited-ico" style="font-size: 10px;"></i></div>
          </div>

          <!-- card infos -->
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutAlign.xs="space-between center" fxLayoutGap="10px" fxFlex *ngIf="card.type=='card' ">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <!-- <img src=" {{card.card.logo_src}}" class="rad-bord logo-card"
                *ngIf="card.card.brand !== 'visa' && card.card.brand !== 'mastercard'">
                <img src="assets/img/refonte-logo/VISA.png" height="40" *ngIf="card.card.brand === 'visa'">
              <img src="assets/img/refonte-logo/MASTERCARD.png" height="40" *ngIf="card.card.brand === 'mastercard'"> -->

              <img src="{{card.card.logo_src}}" class="rad-bord "  class="h-10">


              <div fxLayout="row" fxLayout.xs="column"  fxLayoutGap.xs="10px">
                <span class="mat-subheading-1 boldest">{{card.card.brand | capitalize}}</span>
                <span class="mat-subheading-2" style="color:grey" fxHide fxShow.xs *ngIf="clientCards.length>1">**** {{card.card.last4}}</span>
              </div>

            </div>
            <span class="mat-subheading-2" style="color:grey" fxHide fxShow.xs *ngIf="clientCards.length<2">**** {{card.card.last4}}</span>
            <span class="mat-subheading-1" style="color:grey" fxHide.xs>**** **** **** {{card.card.last4}}</span>

          </div>

          <!-- paypal sepa_debit bancontact -->
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" fxFlex *ngIf="card.type!='card' ">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <img src="assets/img/refonte-logo/PAYPAL.png"  class="h-10" *ngIf="card.type === 'paypal'">
              <img src="assets/img/refonte-logo/BANCONTACT.png"  class="h-10" *ngIf="card.type === 'bancontact'">
              <span class="mat-subheading-1 boldest">{{ card.type |     capitalize}}</span>
            </div>
          </div>




          <!-- set favorite -->

          <div fxLayoutAlign="center center" class="layout-padd" style="margin-top: -5px;"
            (click)="setDefaultPaymentStripeMethod(card,$event);$event.stopPropagation();" *ngIf="clientCards.length>1">
            <mat-icon fontSet="material-icons-outlined"
              *ngIf=" !defaultStripePayMethod|| defaultStripePayMethod && defaultStripePayMethod.id!=card.id">star_rate</mat-icon>
            <mat-icon *ngIf="defaultStripePayMethod && defaultStripePayMethod.id==card.id"
              style="color:rgba(245, 196, 1, 0.897);">star_rate
            </mat-icon>
          </div>



          <!--menu      delete -->
          <div fxLayoutAlign="center center" class="layout-padd" style="margin-top: -5px;">
            <mat-icon mat-icon-button class="dark-ico" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation();">
              more_vert</mat-icon>
            <mat-menu #menu="matMenu">
              <!-- <button mat-menu-item (click)="openDialDeletCard(card, index); $event.stopPropagation();"
              angulartics2On="click" angularticsAction="openDeleteDialog"
              angularticsCategory="paymentMethods">{{"basket.delete" |
              translate}}</button> -->
              <button mat-menu-item (click)="openDialDeletePaymentMethod(card, index); $event.stopPropagation();"
                angulartics2On="click" angularticsAction="openDialDeletePaymentMethod"
                angularticsCategory="paymentMethods">{{"basket.delete" |
                translate}}</button>
            </mat-menu>
          </div>
        </div>

      </div>

    </div>




    <!-- stripe paiements multi moyens de paiements -->
    <div fxLayout="column" fxLayoutGap="10px" *ngIf="currSM.enable_online_payment> 0 && currPOS.stripe_account">

      <div fxLayout="row" class="fake-form-field-endorder clicked" (click)="selectPaymentMethod('stripe')">

        <!-- Radio btn -->
        <div fxLayoutAlign="center center" style="padding: 10px;">
          <div class="fake-radio" *ngIf="currPaymentMethod !== 'stripe' "></div>
          <div class="fake-radio primary" fxLayoutAlign="center center" *ngIf="currPaymentMethod == 'stripe'"><i
              class="fas fa-check whited-ico" style="font-size: 10px;"></i></div>
        </div>


        <!--  content -->
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <img src="assets/img/refonte-logo/STRIPE.png"  class="h-10">
          <span class="mat-subheading-1 boldest">{{'PaymentMethodComponent.payment_online'|translate}}</span>
        </div>



      </div>

    </div>






    <!-- Autres moyens de paiement -->
    <div fxLayout="column" fxLayoutGap="10px" *ngIf="currPOS.paypal_account || currPOS.country.id === 22 && currSM.enable_online_payment> 0 &&
      currPOS.stripe_account || currSM.enable_counter_payment>
      0 && currSM.enable_secure_counter_payment <1 || currSM.enable_counter_payment> 0 &&
        currSM.enable_secure_counter_payment > 0 || currPOS.payzen_account ">


      <!-- Payzen -->
      <div fxLayout="row" class="fake-form-field-endorder clicked" (click)="selectPaymentMethod('payzen')"
        *ngIf="currPOS.payzen_account">

        <!-- Radio btn -->
        <div fxLayoutAlign="center center" style="padding: 10px;">
          <div class="fake-radio" *ngIf="currPaymentMethod !== 'payzen'"></div>
          <div class="fake-radio primary" fxLayoutAlign="center center" *ngIf="currPaymentMethod === 'payzen'"><i
              class="fas fa-check whited-ico" style="font-size: 10px;"></i></div>
        </div>

        <!-- Address content -->
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <img src="assets/img/refonte-logo/PAYZEN.png"  class="h-10">
          <span class="mat-subheading-1 boldest">{{'PaymentMethodComponent.payment_online'|translate}}</span>
        </div>

      </div>


      <!-- Paypal -->

      <div fxLayout="row" class="fake-form-field-endorder clicked" (click)="selectPaymentMethod('online_paypal')"
        *ngIf="currPOS.paypal_account">

      <!-- Radio btn -->
      <div fxLayoutAlign="center center" style="padding: 10px;">
          <div class="fake-radio" *ngIf="currPaymentMethod !== 'online_paypal'"></div>
          <div class="fake-radio primary" fxLayoutAlign="center center" *ngIf="currPaymentMethod === 'online_paypal'"><i
              class="fas fa-check whited-ico" style="font-size: 10px;"></i></div>
        </div>

      <!-- Address content -->
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <img src="assets/img/refonte-logo/PAYPAL.png"  class="h-10">
          <span class="mat-subheading-1 boldest">Paypal</span>
        </div>

      </div>

      <!-- Bancontact -->
      <!-- <div fxLayout="row" class="fake-form-field-endorder clicked" (click)="selectPaymentMethod('bancontact')" *ngIf="currPOS.country.id === 22 && currSM.enable_online_payment> 0 &&
      currPOS.stripe_account"> -->

      <!-- Radio btn -->
      <!-- <div fxLayoutAlign="center center" style="padding: 10px;">
          <div class="fake-radio" *ngIf="currPaymentMethod !== 'bancontact'"></div>
          <div class="fake-radio primary" fxLayoutAlign="center center" *ngIf="currPaymentMethod === 'bancontact'"><i
              class="fas fa-check whited-ico" style="font-size: 10px;"></i></div>
        </div> -->

      <!-- Address content -->
      <!-- <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <img src="assets/img/refonte-logo/BANCONTACT.png" height="40">
          <span class="mat-subheading-1 boldest">Bancontact</span>
        </div>

      </div>  -->

      <!-- Counter -->
      <div fxLayout="row" class=" clicked"
           [ngClass]="cssService.sectionCardClass" (click)="selectPaymentMethod('counter')" *ngIf="currSM.enable_counter_payment>
        0 && currSM.enable_secure_counter_payment <1">

        <!-- Radio btn -->
        <div fxLayoutAlign="center center" style="padding: 10px;">
          <div class="fake-radio" *ngIf="currPaymentMethod !== 'counter'"></div>
          <div class="fake-radio primary" fxLayoutAlign="center center" *ngIf="currPaymentMethod === 'counter'"><i
              class="fas fa-check whited-ico" style="font-size: 10px;"></i></div>
        </div>

        <div fxLayout="column" fxLayoutGap="5px">

          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">


            <img src="assets/img/refonte-logo/PAIEMENT_COMPTOIR.png"  class="h-10">

            <!-- voir icon  -->

            <span class="mat-subheading-1 boldest" *ngIf="currSM.enable_delivery <1">{{"endorder.counter-payment"
              | translate}}</span>
            <span class="mat-subheading-1 boldest" *ngIf="currSM.enable_delivery> 0">{{"endorder.delivry-payment"
              | translate}}</span>

          </div>

          <div *ngIf="currSM.enable_delivery <1">
            <span class="mat-caption">{{"endorder.counter-payment-msg" |
              translate}}</span>
          </div>

        </div>


      </div>

      <!-- Secure counter -->
      <div fxLayout="column" fxLayoutGap="5px"
           [ngClass]="cssService.sectionCardClass"
           class=" clicked"
        (click)="selectPaymentMethod('secure_counter')" *ngIf="currSM.enable_counter_payment> 0 &&
        currSM.enable_secure_counter_payment > 0">

        <!-- Radio btn -->
        <div fxLayout="row">

          <div fxLayoutAlign="start center" style="padding: 10px;">
            <div class="fake-radio" *ngIf="currPaymentMethod !== 'secure_counter'"></div>
            <div class="fake-radio primary" fxLayoutAlign="center center"
              *ngIf="currPaymentMethod === 'secure_counter'">
              <i class="fas fa-check whited-ico" style="font-size: 10px;"></i>
            </div>
          </div>

          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">


            <img src="assets/img/refonte-logo/PAIEMENT_COMPTOIR.png"  class="h-10">

            <!-- voir icon  -->

            <span class="mat-subheading-1 boldest" *ngIf="currSM.enable_delivery <1">{{"endorder.counter-payment"
              | translate}}</span>
            <span class="mat-subheading-1 boldest" *ngIf="currSM.enable_delivery> 0">{{"endorder.delivry-payment"
              | translate}}</span>

          </div>

        </div>

        <!-- Reste de la card, padding left pour aligner avec le titre  -->
        <div fxLayout="column" style="padding-left: 35px;">

          <div fxLayout="column" *ngIf="currSM.enable_delivery <1">
            <span class="mat-caption">{{"endorder.counter-secure-payment-msg"
              | translate}}</span>
            <span class="mat-caption secondary-ico">{{"endorder.counter-payment-beforehand-msg"
              | translate}}
            </span>
          </div>

          <div fxLayout="column" *ngIf="currSM.enable_delivery> 0">
            <span class="mat-caption">{{"endorder.delivry-payment-msg"
              | translate}}
            </span>
          </div>



          <app-cards-endorder id="paimentcard" [currPaymentMethod]="currPaymentMethod" [clientCards$]="clientCards" [from]="'order'" [showDelete]="false"
            (setClientCardsEvent)="setClientCards($event)"  (selectPaymentEvent)="selectPaymentMethod($event)"></app-cards-endorder>

          <div fxLayout="row" fxLayoutAlign="end" fxFlex *ngIf="currSM.enable_online_payment> 0 &&
            currPOS.stripe_account && clientCards.length ===0 " (click)="changeComp('create')">
            <span class="mat-caption boldest primary-ico clicked" (click)="changeComp('create')">+ Ajouter</span>
          </div>

          <!-- Error message -->
          <div fxLayout="row"  fxFlex *ngIf="cardNeeded && clientCards.length === 0" id="cardneeded" (click)="changeComp('create')">
            <span class="mat-caption boldest warn-ico">{{'PaymentMethodComponent.cardRequired'|translate}} </span>
          </div>

        </div>

      </div>

    </div>

    <!-- <div *ngIf="(currSM.enable_online_payment > 0 || currSM.enable_secure_counter_payment > 0) &&
      currPOS.stripe_account">
      <span class="boldest primary-ico clicked" (click)="changeComp('create')">+ Ajouter un moyen de paiement</span>
    </div> -->




    <div fxFlex></div>

    <button mat-raised-button class="rounded-button primary full-w" (click)="closeDial()">
      {{'button.validate'|translate}}

    </button>


  </div>





  <!-- Create card comp -->
  <div fxLayout="column" fxLayoutGap="20px" fxLayoutGap.xs="10px" *ngIf="currComp === 'create'" class="layout-padd">

    <!-- Title bar -->
    <div fxLayout="row" fxLayoutGap="10px" class="clicked" (click)="changeComp('select')">
      <mat-icon>arrow_back_ios</mat-icon>
      <span>{{"dialogs.go-back" | translate}}</span>
    </div>
    <div>
      <span class="mat-headline boldest">{{'PaymentMethodComponent.newCard'|translate}} </span>
    </div>

    <!-- Icons bar-->
    <div fxLayout="column" fxLayoutGap="10px" fxLayoutGap.xs="5px">

      <div>
        <img src="assets/img/refonte-logo/powered_by_stripe.png"  class="h-10">
      </div>

      <div fxLayout="row wrap" fxLayoutGap="5px">
        <img src="assets/img/refonte-logo/MASTERCARD.png" class="rad-bord h-10">
        <img src="assets/img/refonte-logo/VISA.png" class="rad-bord h-10">
        <img src="assets/img/refonte-logo/AMEX.png" class="rad-bord h-10">
        <img src="assets/img/refonte-logo/JCB.png" class="rad-bord h-10">
        <img src="assets/img/refonte-logo/DINERS_CLUB.png" class="rad-bord h-10">
        <img src="assets/img/refonte-logo/DISCOVER.png" class="rad-bord h-10">
      </div>

    </div>

    <!-- Card Form  -->
    <div fxLayout="column" fxLayoutGap="10px">

      <!-- Numero card input -->
      <div fxLayout="column" class="fake-form-field-endorder-card">

        <div fxLayoutAlign="start center">
          <span class="mat-caption">{{'PaymentMethodComponent.numberCard'|translate}}</span>
        </div>

        <div>
          <div id="cardNumber"></div>
        </div>

      </div>

      <!-- Expiration card input -->
      <div fxLayout="column" class="fake-form-field-endorder-card">

        <div>
          <span class="mat-caption">{{'PaymentMethodComponent.exp'|translate}} </span>
        </div>

        <div>
          <div id="cardExpiry"></div>
        </div>

      </div>

      <!-- CVC card input -->
      <div fxLayout="column" class="fake-form-field-endorder-card">

        <div>
          <span class="mat-caption">CVC</span>
        </div>

        <div>
          <div id="cardCvc"></div>
        </div>

      </div>

      <div>

        <mat-checkbox angulartics2On="click" angularticsAction="checkBoxRegisterForLater"
          angularticsCategory="paymentMethods" color="primary" [(ngModel)]="rememberCard" *ngIf="user$">
          {{'PaymentMethodComponent.saveCard'|translate}}
        </mat-checkbox>
      </div>


      <!-- Error and Submit button -->
      <div fxLayout="column" fxLayoutGap="5px">

        <!-- Error message -->
        <div fxLayout="row" fxLayoutAlign="center center" class="warn rad-bord layout-padd text-center"
          *ngIf="errorMessage">
          <span class="mat-subheading-1">{{errorMessage}}</span>
        </div>

        <!-- Submit button -->
        <button mat-raised-button class="full-w rounded-button" color="primary" (click)="submitForm()"
          angulartics2On="click" angularticsAction="submitCreate" angularticsCategory="paymentMethods"
          (blur)="errorMessage=null">
          {{'button.validate'|translate}}
        </button>

      </div>

    </div>

  </div>



  <app-popup-loader [flagLoading]="loader" [size]="30"></app-popup-loader>

</div>
